var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"login"}},[_c('p',{staticClass:"login-margin"},[_c('a',{staticClass:"btn btn-default",attrs:{"href":_vm.oauth_server}},[_vm._v("Einloggen bei Bexio")])]),_vm._m(0),_c('p',[_vm._v("Copyright Ctek AG")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('img',{attrs:{"width":"600","src":require("./../assets/logo.png")}})])
}]

export { render, staticRenderFns }